export enum ENUM__invocation_role {
  GRID2D__VIEW = 'grid2d:view',

  T2I_ADAPTER__COLOR = 't2i_adapter:color',

  IP_ADAPTER__REFERENCE_IMAGES_1 = 'ip_adapter:reference_images:1',
  IP_ADAPTER__REFERENCE_IMAGES_2 = 'ip_adapter:reference_images:2',

  CONTROL___CANNY = 'control:canny',
  CONTROL___DEPTH = 'control:depth',

  IMAGE__CROP = 'image:crop',
  IMAGE__MASK__CREATE_GRADIENT = 'image:mask:create_gradient',
  IMAGE__PASTE_WITH_MASK = 'image:paste_with_mask',

  CORE__TEXT_ENCODER = 'core:text_encoder',
  CORE__DENOISE = 'core:denoise',
  CORE__LATENTS_NOISE = 'core:latents:noise',
  CORE__LATENTS_TO_IMAGE = 'core:latents_to_image',
  CORE__LORAS_SELECT = 'core:loras_select',
  CORE__IMAGE_TO_LATENTS = 'core:image_to_latents',

  CORE__IMAGE_VIEWPORT = 'core:viewport',

  VISION__LINE_CANNY = 'vision:line:canny',
  VISION__LINE_CANNY__AUTO = 'vision:line:canny:auto',
  VISION__LINE_CANNY__SEMI_AUTO = 'vision:line:canny:semi_auto',

  VISION__LINE_HED = 'vision:line:hed',

  VISION__REMBG = 'vision:rembg',
  VISION__COLOR_MAP = 'vision:color_map',

  UNKNOWN = '',
}
